import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SignOut() {
    const navigate = useNavigate();

    useEffect(() => {
        // Here you would typically clear any user session data
        // For now, we'll just redirect to the login page
        navigate('/login');
    }, [navigate]);

    return <h1 className="text-xl font-bold">Signing Out</h1>;
}
